import { AbstractControl } from "@angular/forms"


export const miniumQuota = (control: AbstractControl) : { [key: string]: any } | null=> {
  const value = control.value;
  if (value != null) {
    let cleanValue = (value).replace(/\./g, "").replace(/[\s]|\$|,/g, "");
    let amountFinance = Number(localStorage.getItem('amountFinance'))
    if(Number(cleanValue) > amountFinance) {
      return {'miniumQuota': true}
    }
    return null;
  } else {
    return null;
  }
}